import { render, staticRenderFns } from "./PurchaseNew_Total.vue?vue&type=template&id=24c2ef8a&"
import script from "./PurchaseNew_Total.vue?vue&type=script&lang=js&"
export * from "./PurchaseNew_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports